import MagnifyingGlassIcon from "assets/img/inbox/search.svg?react";
import { XMarkIcon } from "components/icons/solid";

export const TableSearch = ({
    value,
    onChange,
    placeholder = "Search",
    ariaLabel = placeholder,
}: {
    value: string;
    onChange?: (search: string) => void;
    placeholder?: string;
    ariaLabel?: string;
}) => {
    return (
        <div className="flex w-full max-w-md items-center rounded-lg border border-[#d4d5d5] bg-brand-polar px-4 py-2">
            <MagnifyingGlassIcon className="mr-2 h-5 w-5 text-gray-700" />
            <input
                type="text"
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder}
                aria-label={ariaLabel}
                className="flex-1 bg-transparent font-medium text-[#424242] placeholder:font-medium placeholder:text-[#424242] focus:outline-hidden"
            />
            {value && (
                <button
                    onClick={() => onChange?.("")}
                    className="ml-2 text-gray-500 focus:outline-hidden"
                    aria-label="Clear"
                >
                    <XMarkIcon className="h-5 w-5 text-gray-500" />
                </button>
            )}
        </div>
    );
};
